type CNetGrid = {
	id: number;
};

type DeleteConfirmationParams = {
	cssrGpEnabled?: boolean;
	cssrBrdcEnabled?: boolean;
	grids: CNetGrid[];
};

type ClearConfirmationParams = {
	cssrGpEnabled?: boolean;
	cssrBrdcEnabled?: boolean;
};


export const deleteConfirmationKey = ({
	cssrGpEnabled,
	grids,
}: DeleteConfirmationParams) => {
	if (cssrGpEnabled && grids.length === 1) {
		return 'deleteCNetTitleGpAlert';
	}
	return 'deleteCNetTitle';
};


export const clearConfirmationKey = ({
	cssrGpEnabled,
}: ClearConfirmationParams) => {
	if (cssrGpEnabled) {
		return 'clearCNetTitleGpAlert';
	}
	return 'clearCNetTitle';
};
